import {resetPassword, validateResetPasswordToken} from "../../services/apollo/reset-password";

export default {
  namespaced: true,
  actions: {
    validateResetPasswordToken({commit}, token) {
      return validateResetPasswordToken(token)
    },
    resetPassword({commit}, {token, password, repeatPassword, gRecaptcha}) {
      return resetPassword(token, password, repeatPassword, gRecaptcha);
    }
  },
}
